import { NotifyIcons, Sizes, State, States } from '@agilox/ui-common';
import { Component, computed, input, model, output } from '@angular/core';
import { IconModule } from '../icon/icon.module';

const CONTENT_CLASSES = 'grid w-full transition-[grid-template-rows] duration-200 ease-in-out';
const CONTENT_EXPANDED_CLASS = 'grid-rows-[1fr]';
const CONTENT_COLLAPSED_CLASS = 'grid-rows-[0fr]';
const CONTENT_PASSTHROUGH_CLASS = 'contents';
const COLLAPSE_ICON = 'x_arrow_up';
const EXPAND_ICON = 'x_arrow_down';

@Component({
	selector: 'ui-notify',
	imports: [IconModule],
	templateUrl: './notify.component.html',
	styleUrls: ['./notify.component.scss'],
})
export class NotifyComponent {
	type = input<State>(States.Info);
	text = input<string>('');
	closable = input<boolean>(false);
	collapsible = input<boolean>(false);
	showBottomPadding = input<boolean>(true);

	expanded = model<boolean>(false);

	closeNotify = output<void>();

	iconStyles = computed(() => {
		switch (this.type()) {
			case States.Success:
				return 'text-[var(--border-color-notify-success)]';
			case States.Warning:
				return 'text-[var(--border-color-notify-warning)]';
			default:
				return 'text-[var(--border-color-notify-info)]';
		}
	});

	wrapperStyles = computed(() => {
		switch (this.type()) {
			case States.Success:
				return `bg-[var(--color-notify-success)] border-[var(--border-color-notify-success)]`;
			case States.Warning:
				return `bg-[var(--color-notify-warning)] border-[var(--border-color-notify-warning)]`;
			default:
				return `bg-[var(--color-notify-info)] border-[var(--border-color-notify-info)]`;
		}
	});

	contentStyles = computed(() => {
		if (!this.collapsible()) {
			return CONTENT_PASSTHROUGH_CLASS;
		}
		return `${CONTENT_CLASSES} ${this.expanded() ? CONTENT_EXPANDED_CLASS : CONTENT_COLLAPSED_CLASS}`;
	});

	innerContentStyles = computed(() =>
		this.collapsible() ? 'overflow-hidden' : CONTENT_PASSTHROUGH_CLASS
	);

	toggleIcon = computed(() => (this.expanded() ? COLLAPSE_ICON : EXPAND_ICON));

	public notifyIcons = NotifyIcons;
	public sizes = Sizes;

	toggle(): void {
		this.expanded.update((expanded) => !expanded);
	}
}
